// @ts-strict-ignore
import { ArticleLocationVO } from '@article/model/vo/article-location.vo';
import { ArticleUsageVO } from '@article/model/vo/article.vo';
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';

@JsonObject('RelativePositionReferenceArticleLocationVO')
export class RelativePositionReferenceArticleLocationVO extends ArticleLocationVO {
  public static readonly RELATIVE_POSITION_LEFT_OF: number = 1;
  public static readonly RELATIVE_POSITION_RIGHT_OF: number = 2;

  @JsonProperty('relativePosition', 'Number')
  public relativePosition: number; // switch over constants above

  @JsonProperty('referenceArticleUsage', 'ArticleUsageVO')
  public referenceArticleUsage: ArticleUsageVO;

  @JsonProperty('rotationAngle', 'Number')
  public rotationAngle: number;

  @JsonProperty('applyRotationDelta', 'Boolean')
  public applyRotationDelta: boolean = false;

  public constructor() {
    super();
  }
}
